import { NGXAjax } from '../../common/Services/AjaxService.js';
import { resolve, reject } from './util/api-util';

function fetchRefData(category, scope, status) {
  return NGXAjax.get(
    `/api/refdata/list.json?category=${category}&scope=${scope}&status=${status}`
  ).then(resolve, reject);
}

export { fetchRefData };
